const CLASS_COMPLETE = 'is-complete';

const initRadioHireProgress = () => {
  const items = document.querySelectorAll('.rh-progress__item');
  if (!items.length) return;

  function updateProgress(step) {
    items.forEach(function (item) {
      const idx = parseInt(item.dataset.stepIndex);
      item.classList.remove('is-active', CLASS_COMPLETE);
      if (idx < step)  item.classList.add(CLASS_COMPLETE);
      if (idx === step) item.classList.add('is-active');
    });
  }

  function getCurrentStep() {
    const params = new URLSearchParams(window.location.search);
    return parseInt(params.get('step') || '1');
  }

  function goToStep(step) {
    const url = new URL(window.location.href);
    url.searchParams.set('step', String(step));
    window.location.href = url.toString();
  }

  items.forEach(function (item) {
    item.addEventListener('click', function () {
      if (!item.classList.contains(CLASS_COMPLETE)) return;
      goToStep(parseInt(item.dataset.stepIndex));
    });
  });

  updateProgress(getCurrentStep());
};

export default initRadioHireProgress;
